import {
  AlertTriangle,
  CircleAlert,
  ClipboardList,
  HelpCircle,
  ListTodo,
  MessageSquareText,
} from 'lucide-react';

const TYPES={
  request:{label:'Request',icon:ClipboardList,tone:'request'},
  question:{label:'Question',icon:HelpCircle,tone:'question'},
  complaint:{label:'Complaint',icon:AlertTriangle,tone:'complaint'},
  task:{label:'Task',icon:ListTodo,tone:'task'},
  incident:{label:'Service issue',icon:CircleAlert,tone:'incident'},
  feedback:{label:'Feedback',icon:MessageSquareText,tone:'feedback'},
};

export function normaliseCaseIssueType(valueOrRecord){
  if(typeof valueOrRecord==='string'){
    const value=String(valueOrRecord||'').trim().toLowerCase();
    return TYPES[value]?value:'request';
  }
  const row=valueOrRecord||{};
  const explicit=String(row.issue_type||'').trim().toLowerCase();
  if(TYPES[explicit])return explicit;
  if(String(row.case_type||row.type||'').trim().toLowerCase()==='complaint')return 'complaint';
  return 'request';
}

export function caseIssueTypeLabel(valueOrRecord){
  return TYPES[normaliseCaseIssueType(valueOrRecord)].label;
}

export default function CaseTypeBadge({type,row,compact=false}){
  const key=normaliseCaseIssueType(type||row);
  const config=TYPES[key];
  const Icon=config.icon;
  return <span className={'case-type-badge type-'+config.tone+(compact?' compact':'')} title={'Work item type: '+config.label}>
    <Icon size={compact?11:13}/>
    <span>{config.label}</span>
  </span>;
}
